import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { ScheduleActions } from "src/core/schedules/store/schedules.actions";
import * as AT from "src/core/schedules/store/schedules.constants";
import { ISchedule } from "src/core/schedules/api/schedules.api";

export interface ISchedulesStore {
  schedule: ISchedule | null;
}

const initialState: ISchedulesStore = { schedule: null };

export const schedulesReducer: Redux.Reducer<ISchedulesStore> = (state: ISchedulesStore = initialState, action: ScheduleActions): ISchedulesStore => {
  switch (action.type) {
    case AT.PURGE_SCHEDULES:
      return initialState;

    case AT.SET_SCHEDULE:
      return {
        ...state,
        schedule: action.schedule
      };

    default:
      return state;
  }
};

export const schedulesPersistConfig = {
  key: "schedules",
  storage,
  blacklist: [ "" ]
};
